// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1rUX5","type":"styles_type__1HTFO","choices":"styles_choices__2xwYo"};